import { AppId } from '@wix/cashier-common/dist/src/enums/AppId';
import { InteractionName } from '../../types/InteractionName';
import { getAppNameById } from '../getAppNameById';

// TPAs that are known to use our Widget (27.06.20)
export const tpasToTrackLoadBy: (AppId | string)[] = [
  AppId.Challenges,
  AppId.PhotoAlbum,
  AppId.RecurringInvoices,
  AppId.ArtStore,
  AppId.Inbox,
  AppId.Music,
  AppId.Video,
  AppId.Hotels,
  AppId.Invoices,
  AppId.Cashier,
  AppId.Events,
  AppId.WixPaidPlans,
  AppId.Bookings,
  AppId.Restaurants,
  AppId.Stores,
];

export const getLoadByInteraction = (appId: string): InteractionName => {
  if (!tpasToTrackLoadBy.includes(appId)) {
    return null;
  }

  const tpaKey: string = getAppNameById(appId)?.toLowerCase();

  if (typeof tpaKey !== 'string' || tpaKey.length === 0) {
    return null;
  }

  return `${InteractionName.WIDGET_LOAD_BY}-${tpaKey}` as InteractionName;
};

// TODO: remove after the issue with low success rate of "ALE_FULL_RENDER" interaction will be resolved
export const tpasToTrackFullRenderBy: (AppId | string)[] = [
  AppId.Cashier,
  AppId.Events,
  AppId.WixPaidPlans,
  AppId.Bookings,
  AppId.Restaurants,
  AppId.Stores,
];

export const getFullRenderByInteraction = (appId: string): InteractionName => {
  if (!tpasToTrackFullRenderBy.includes(appId)) {
    return null;
  }

  const tpaKey: string = getAppNameById(appId)?.toLowerCase();

  if (typeof tpaKey !== 'string' || tpaKey.length === 0) {
    return null;
  }

  return `${InteractionName.ALE_FULL_RENDER_BY}-${tpaKey}` as InteractionName;
};
